import { FC } from 'react'

import ContentCard, { ContentCardProps } from '../ContentCard'
import Icon from '../Icon'

import * as SC from './styled'

export type ContentCardGroupProps = {
  className?: string
  backgroundColor?: string
  cards: ContentCardProps[]
}

const ContentCardGroup: FC<ContentCardGroupProps> = (props) => {
  const { className, cards, backgroundColor } = props

  return (
    <SC.Group className={className}>
      {cards[0] && (
        <SC.FirstCard>
          <ContentCard {...cards[0]} />
        </SC.FirstCard>
      )}
      <SC.PlusCircle backgroundColor={backgroundColor}>
        <Icon icon="plus"></Icon>
      </SC.PlusCircle>
      {cards[1] && (
        <SC.SecondCard>
          <ContentCard {...cards[1]} />
        </SC.SecondCard>
      )}
    </SC.Group>
  )
}

export default ContentCardGroup
